// getUserListAction.js
import { getUsers } from "../../services/user.services";

export const SET_USER_LIST = "SET_USER_LIST";

export const fetchUserList = () => {
  return async (dispatch) => {
    try {
      const response = await getUsers(JSON.parse(sessionStorage.getItem("myData")));
      dispatch({
        type: SET_USER_LIST,
        payload: response.data,
      });
    } catch (error) {
      console.log("Error fetching user list:", error);
    }
  };
};
